import React from 'react';

const CookiesEs = () => {
  return (
    <div className="EN">
      <div>
        <p className="p1">
          <span className="s1"><b>¿QUÉ ES UNA COOKIE Y PARA QUÉ SE UTILIZA?</b></span>
        </p>
        <p className="p1">
          <span className="s1">Una cookie es un pequeño archivo de datos que, en forma de código anónimo único, se envía a su navegador desde un servidor web y luego se almacena en el disco duro de su dispositivo (ordenador, smartphone y/o tableta). Las cookies pueden permitir el uso correcto de un sitio de Internet (las llamadas cookies técnicas o necesarias), o pueden actuar como verificaciones de las preferencias del Usuario en el contexto de la navegación en línea para proponer mensajes publicitarios (las llamadas cookies de perfil). Las cookies pueden almacenarse permanentemente en el dispositivo durante un período de duración variable (las llamadas cookies permanentes), o pueden eliminarse al cerrar el navegador o tener una duración limitada (las llamadas cookies de sesión). Las cookies pueden ser instaladas por el sitio web que está visitando (las llamadas cookies de primera parte) o pueden ser instaladas por otros sitios web (las llamadas cookies de terceros).</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1"><b>LAS COOKIES UTILIZADAS EN ESTE SITIO WEB Y LOS PROPÓSITOS DE DICHO USO</b></span>
        </p>
        <p className="p1">
          <span className="s1">Este sitio web utiliza las siguientes cookies:</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1"><b>Cookies necesarias/técnicas</b></span>
        </p>
        <p className="p1">
          <span className="s1">Estas cookies permiten que el sitio web funcione correctamente, haciendo posible ver su contenido en el idioma y mercado relacionados desde la primera visita del Usuario, entonces este es el propósito de dichas cookies técnicas necesarias. Son capaces de reconocer el país desde el cual el Usuario se está conectando y garantizan que el Usuario sea orientado automáticamente a la versión del sitio web aplicable para su país en cada visita. Estas cookies son necesarias para el funcionamiento del sitio web.</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1"><b>Lista de cookies</b></span>
        </p>
        <p className="p1">
          <span className="s1">Una cookie es una pequeña cantidad de datos (un archivo de texto) que un sitio web solicita al navegador almacenar en el dispositivo cuando es visitado por un usuario para recordar su información, como su idioma preferido o detalles de inicio de sesión. Estas cookies son establecidas por nosotros y se llaman cookies de primera parte. También utilizamos cookies de terceros (cookies de un dominio diferente al sitio web que está visitando) para fines publicitarios y de marketing. En particular, utilizamos cookies y otras tecnologías de seguimiento para estos fines:</span>
        </p>
        <br/>
        <div className="my-10" >
          <table className="w-full table-auto">
            <thead>
              <tr>
                <td>Subgrupo de cookies</td>
                <td>Cookies</td>
                <td>Finalidad</td>
                <td>Cookies utilizadas</td>
                <td>Vida útil</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>*.valentino.com</td>
                <td>Idioma del navegador</td>
                <td>Idioma por defecto</td>
                <td>Primera Parte</td>
                <td>Sesión</td>
              </tr>
              <tr>
                <td></td>
                <td>Sistema operativo, tipo y versión del navegador</td>
                <td>Descarga de VCard y generación de código QR</td>
                <td>Primera Parte</td>
                <td>Sesión</td>
              </tr>
              <tr>
                <td></td>
                <td>Dimensión de la ventana gráfica</td>
                <td>Respuesta de la aplicación</td>
                <td>Primera Parte</td>
                <td>Sesión</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br/>
        <p className="p1">
          <span className="s1"><b>Cookies analíticas</b></span>
        </p>
        <p className="p1">
          <span className="s1">Estas cookies se utilizan para crear análisis estadísticos sobre la forma en que los Usuarios navegan por el sitio web, por ejemplo el dispositivo utilizado, el número de páginas visitadas o el número de clics en una página particular durante la navegación. Los resultados de estos análisis se procesan de forma anónima y solo con fines estadísticos. Entonces el análisis estadístico agregado sobre el uso del sitio web es el propósito del procesamiento. Solo utilizamos cookies que rastrean direcciones IP anónimas (con una porción del código no visible); tales cookies se asimilan a las cookies técnicas ya que no permiten la identificación de usuarios y no necesitan ningún consentimiento para ser utilizadas.</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1"><b>CONSERVACIÓN DE DATOS</b></span>
        </p>
        <p className="p1">
          <span className="s1">Tenga en cuenta que la vida útil de cada cookie se indica en las tablas anteriores. Los datos recopilados por las cookies serán conservados por el Responsable del tratamiento durante un máximo de 37 meses y luego cancelados o anonimizados.</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1"><b>BASE LEGAL PARA EL USO DE COOKIES</b></span>
        </p>
        <p className="p1">
          <span className="s1">No se requiere consentimiento para el uso de cookies técnicas (incluidas las cookies analíticas anonimizadas); por lo tanto, se procesan sobre la base del interés legítimo del propietario para proporcionar una navegación y uso mejorados del sitio web.</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1"><b>CÓMO SE PROCESAN SUS DATOS PERSONALES</b></span>
        </p>
        <p className="p1">
          <span className="s1">Sus datos personales serán procesados por herramientas automatizadas durante el tiempo estrictamente necesario para lograr los propósitos para los cuales se recopilaron dichos datos (consulte la duración específica de las cookies en las tablas anteriores y la sección CONSERVACIÓN DE DATOS anterior). Se han adoptado medidas específicas de seguridad, técnicas y organizativas para prevenir la pérdida de datos, el uso ilícito o incorrecto y el acceso no autorizado.</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1"><b>DERECHO DE LOS USUARIOS A OPONERSE O EDITAR COOKIES</b></span>
        </p>
        <p className="p1">
          <span className="s1">Puede oponerse al almacenamiento de cookies en su disco duro configurando su navegador de manera que desactive las cookies. Hemos establecido a continuación los procedimientos disponibles en los principales navegadores:</span>
        </p>
        <p className="p1">
          <span className="s1">• Chrome: <a href="https://support.google.com/chrome/answer/95647?hl=it">https://support.google.com/chrome/answer/95647?hl=it</a></span>
        </p>
        <p className="p1">
          <span className="s1">• Firefox: <a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie">https://support.mozilla.org/it/kb/Gestione%20dei%20cookie</a></span>
        </p>
        <p className="p1">
          <span className="s1">• Safari: <a href="http://support.apple.com/kb/HT1677?viewlocale=it_IT">http://support.apple.com/kb/HT1677?viewlocale=it_IT</a></span>
        </p>

        <p className="p1">
          <span className="s1">Es posible, sin embargo, que después de completar la operación anterior, varias funciones de la página web no funcionen correctamente.</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1"><b>RESPONSABLE DEL TRATAMIENTO</b></span>
        </p>
        <p className="p1">
          <span className="s1">El responsable del tratamiento de los datos recopilados por las cookies es Valentino S.p.A. con domicilio social en Via Turati 16/18, 20121, Milano (MI), Italia. Valentino S.p.A. ha designado un delegado de protección de datos, que puede ser contactado en la siguiente dirección de correo electrónico: <a href="mailto:privacy@valentino.com">privacy@valentino.com</a>. Para cualquier información sobre el tratamiento de sus datos personales, para presentar una queja y ejercer los derechos establecidos a continuación, también puede contactar al responsable del tratamiento escribiendo a Valentino, via Turati 16/18, 20121 Milano (a la atención del Departamento Legal, que está designado para recibir y gestionar dichas solicitudes, involucrando también a los departamentos relevantes, según los procedimientos internos de Valentino).</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1"><b>QUIÉN TENDRÁ CONOCIMIENTO DE LOS DATOS, SU TRANSFERENCIA Y DIVULGACIÓN</b></span>
        </p>
        <p className="p1">
          <span className="s1">Los datos adquiridos por las cookies serán y podrán llegar al conocimiento de los siguientes:</span>
        </p>
        <p className="p1">
          <span className="s1">• Empleados y colaboradores del responsable, actuando en calidad de persona autorizada para efectuar el tratamiento; y,</span>
        </p>
        <p className="p1">
          <span className="s1">• Proveedores de servicios técnicos y organizativos actuando en calidad de encargados del tratamiento.</span>
        </p>
        <p className="p1">
          <span className="s1">Podemos transferir los datos adquiridos por el uso de cookies al extranjero, incluso a países fuera de la UE, con la garantía, sin embargo, de protecciones y defensas apropiadas. Para obtener información sobre la ubicación exacta de los datos, se le invita a escribir al responsable en <a href="mailto:privacy@valentino.com">privacy@valentino.com</a>.</span>
        </p>
        <p className="p1">
          <span className="s1">Los datos no serán divulgados de manera general de ninguna manera.</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1"><b>DERECHOS DE LOS USUARIOS</b></span>
        </p>
        <p className="p1">
          <span className="s1">El usuario siempre tiene el derecho de obtener de VALENTINO la confirmación de si existen o no datos personales que le conciernen, incluso si aún no están registrados, y de tenerlos comunicados en una forma inteligible. Un usuario también tiene el derecho de obtener información sobre la fuente de los datos personales; los propósitos y métodos de tratamiento, la lógica aplicada en el caso de tratamiento que se realiza con la ayuda de instrumentos electrónicos; los detalles de identificación del responsable y los encargados del tratamiento; y la indicación de las personas o categorías de personas cuyos datos personales pueden ser comunicados. Un usuario también tiene el derecho de solicitar una actualización, corrección o, cuando tenga interés en hacerlo, una inclusión de datos personales, eliminación, conversión a una forma anónima o el bloqueo de datos personales que han sido procesados en violación de la ley, incluyendo datos que no es necesario mantener en relación con los propósitos para los cuales fueron recopilados o procesados posteriormente; una declaración de que las operaciones anteriores fueron divulgadas, incluso en términos de su contenido, a aquellas partes a las que se comunicaron los datos, excepto en el caso en que tal desempeño resulte imposible o conlleve el uso de métodos claramente desproporcionados al derecho protegido. El usuario también puede solicitar la portabilidad de sus datos. Además, el usuario tiene el derecho de solicitar la restricción del tratamiento de sus datos personales.</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1">Un usuario, sin embargo, tiene el derecho de oponerse, en parte o en su totalidad, por razones legítimas, al tratamiento de datos personales que le conciernen, incluso si es pertinente al alcance de la recopilación.</span>
        </p>
        <br/>

        <p className="p1">
          <span className="s1">Puede ejercer los derechos anteriores y solicitar información y preguntas adicionales sobre el tratamiento de sus datos personales contactando a VALENTINO y al Delegado de Protección de Datos escribiendo a <a href="mailto:privacy@valentino.com">privacy@valentino.com</a> (tenga en cuenta que la entrega de una solicitud por correo electrónico conlleva la adquisición posterior de la dirección del remitente, necesaria para responder a las solicitudes y llevar un registro de ellas, así como cualquier otro dato personal incluido en la comunicación electrónica, para fines legales). También puede escribir por correo a VALENTINO, via Turati 16/18, 20121, Milano (Italia), a la atención del Departamento Legal.</span>
        </p>
        <br/>
        <p className="p1">
          <span className="s1">Finalmente, tenga en cuenta que tiene el derecho de presentar una queja ante la Autoridad Italiana de Protección de Datos (Garante per la Protezione dei Dati Personali), con sede en Piazza Venezia, 11, 00187 Roma (<a href="http://www.garanteprivacy.it/">www.garanteprivacy.it</a>), o ante otra autoridad de supervisión de protección de datos en el país en el que reside.</span>
        </p>
      </div>
    </div>
  );
};

export default CookiesEs;


